/* global google */

import React from 'react'
import PropTypes from 'prop-types'
import { compose, withProps } from 'recompose' // eslint-disable-line import/no-extraneous-dependencies
import { DrawingManager as DrawingTool } from 'react-google-maps/lib/components/drawing/DrawingManager'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap as Map,
  Marker as Pin,
  Polygon as ShapePolygon,
  InfoWindow,
} from 'react-google-maps'
import { customProperties } from 'config/variables'

import SvgPin from 'assets/svgs/pin.svg'

import config from '../../config'

const polygonOptions = {
  fillColor: customProperties.swatchSecondary,
  fillOpacity: 0.3,
  strokeColor: customProperties.swatchSecondary,
  strokeOpacity: 0.9,
  strokeWeight: 3,
}

/**
 * For all available options see plugin documentation
 * @link https://tomchentw.github.io/react-google-maps/
 */

const GoogleMap = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${
      config.GM_API_KEY
    }&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div id="map" style={{ height: '100%' }} />,
    mapElement: <div style={{ height: '100%' }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(({ children, ...restProps }) => (
  <Map
    defaultZoom={11}
    defaultCenter={{ lat: 59.32932349, lng: 18.0685808 }}
    {...restProps}
  >
    {children}
  </Map>
))

const Marker = ({ children, ...props }) => (
  <Pin defaultIcon={SvgPin} {...props}>
    {children}
  </Pin>
)

Marker.propTypes = {
  children: PropTypes.node,
}

Marker.defaultProps = {
  children: null,
}

const Polygon = props => <ShapePolygon options={polygonOptions} {...props} />

const DrawingManager = props => (
  <DrawingTool
    defaultDrawingMode={google.maps.drawing.OverlayType.POLYGON}
    defaultOptions={{
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [google.maps.drawing.OverlayType.POLYGON],
      },
      polygonOptions,
    }}
    {...props}
  />
)

export default GoogleMap
export { Marker, Polygon, DrawingManager, InfoWindow }



// WEBPACK FOOTER //
// ../source/components/GoogleMap/index.js